import axios from 'axios'
const { VUE_APP_API_URL, VUE_APP_TEST_ERROR, VUE_APP_VT_API_URL } = process.env

const getCancellationConditions = async (bookno, bookname) => {
  const result = { error: false }
  try {
    const url = VUE_APP_TEST_ERROR || `${VUE_APP_API_URL}/api/xport/CANXCOND/${bookno}/${bookname}?rnd=${Math.random()}`

    const res = await axios
      .get(url)
    if (res && res.data) {
      const g = res.data.sfactsinfo.split('^')
      const y = g.length
      if (g[3].indexOf('error') >= 0) {
        result.data = ''

        return result
      } else {
        let str = g[(y - 2)]
        str = str.replace(/\\u003c/g, '<')
        str = str.replace(/\\u003e/g, '>')
        str = str.replace(/\\u0026/g, '&')
        str = str.replace(/\\u0027/g, '\'')
        str = str.replace(/\\"/g, '"')
        str = str.replace(/\\u003d/g, '=')
        result.data = str

        return result
      }
    }
  } catch (err) {
    result.error = true
    return result
  }
}
 const sendSMS = async (_data) => {
  const url = VUE_APP_TEST_ERROR || `${VUE_APP_API_URL}/api/vt-canx/send-sms`
  try {
    const res = await axios
      .post(url, _data)
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}
const checkSMS = async (_data) => {
  const url = VUE_APP_TEST_ERROR || `${VUE_APP_API_URL}/api/vt-canx/check-code`
  try {
    const res = await axios
      .post(url, _data)
    if (res && res.data) {
      return res.data
    }
  } catch (err) {
    return null
  }
}
const submitCancellation = async (data, token) => {
  const result = { error: false }
  try {
    const res = await axios
      .post(`${VUE_APP_VT_API_URL}/vt-api/viewtrail/cancellation`, data,{
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    if (res && res.data) {
      return result
    }
  } catch (err) {
    result.error = true
    return result
  }
}
const submitIntCancellation = async (data, token) => {
  const result = { error: false }
  try {
    const res = await axios
      .post(`${VUE_APP_VT_API_URL}/vt-api/viewtrail/int/cancellation`, data, {
        headers: {
          responseType: 'blob',
          Authorization: `Bearer ${token}`
        }
      })
    if (res && res.data) {
      return res
    }
  } catch (err) {
    result.error = true
    return result
  }
}
export {
  getCancellationConditions, sendSMS, checkSMS, submitCancellation, submitIntCancellation
}
